import { defineMessages } from 'react-intl'

export const billingHistoryMessages = defineMessages({
  title: {
    id: 'billingHistory.title',
    description: 'Heading text for "Billing History" page',
    defaultMessage: 'Billing History',
  },
  noHistory: {
    id: 'billingHistory.noHistory',
    description: 'Text for empty Billing History state',
    defaultMessage: 'No billing history yet',
  },
  date: {
    id: 'billingHistory.date',
    description: 'Header for Billing History table column "Date"',
    defaultMessage: 'Date',
  },
  homeName: {
    id: 'billingHistory.homeName',
    description: 'Header for Billing History table column "Home Name"',
    defaultMessage: 'Home Name',
  },
  description: {
    id: 'billingHistory.description',
    description: 'Header for Billing History table column "Description"',
    defaultMessage: 'Subscription',
  },
  paymentMethod: {
    id: 'billingHistory.paymentMethod',
    description: 'Header for Billing History table column "Payment Method"',
    defaultMessage: 'Payment Method',
  },
  amount: {
    id: 'billingHistory.amount',
    description: 'Header for Billing History table column "Amount"',
    defaultMessage: 'Amount',
  },
})
